module.exports = __webpack_public_path__ + "img/kopsurat_neurovi_default_sm.80f97448.png";